import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Box, Chip, Stack, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { sendTalkToSalesEmail } from 'wisestep-api';
import { Label, WsColors } from 'wisestep-base';

import { useWorkspaceSKUContext } from '../../context';
import { warning, success } from '../../utils/NotificationMessages';
import { useNotificationStore } from '../../utils/NotificationStore';

const RenAppBarr = styled(Box)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 10,
  height: '40px',
  paddingTop: 5,
}));

const CustomChip = styled(Chip)(() => ({
  borderRadius: 4,
  marginBottom: '10px',
  cursor: 'pointer',
}));

const NoticeUI = ({ days }: { days: number }) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const workspaceSKU = useWorkspaceSKUContext();

  const navigate = useNavigate();

  const colorHandler = () => {
    const color = { bgColor: '', textColor: '' };
    if (days != null) {
      if (workspaceSKU.workspacePlan?.planCode === 'TRIAL') {
        if (days > 7) {
          color.bgColor = WsColors.TheBlues100;
          color.textColor = WsColors.TheBlues500;
        } else if (days <= 7) {
          color.bgColor = WsColors.Yellow300;
          color.textColor = WsColors.YellowCompliment;
        } else if (days <= 0) {
          color.bgColor = WsColors.Red500;
          color.textColor = WsColors.White;
        }
      } else {
        if (days > 7) {
          color.bgColor = WsColors.TheBlues100;
          color.textColor = WsColors.TheBlues500;
        } else if (days < 0) {
          color.bgColor = WsColors.Red500;
          color.textColor = WsColors.White;
        } else if (days <= 7) {
          color.bgColor = WsColors.TheBlues100;
          color.textColor = WsColors.TheBlues500;
        }
      }
    }
    return color;
  };

  const sendEmailToSales = async () => {
    try {
      const response = await sendTalkToSalesEmail();
      if (response.status === 200) {
        setNotification(success('Contact Request Sent Successfully'));
      }
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };

  const checkPlanForMessage = (days: number) => {
    if (days < 0) {
      return 'Subscription: Expired';
    } else if (days > 0 && workspaceSKU.workspacePlan?.planCode != 'TRIAL') {
      return `Subscription: Renews in ${days} days`;
    } else if (days > 0 && workspaceSKU.workspacePlan?.planCode === 'TRIAL') {
      return `Subscription: Expires in ${days} days`;
    } else if (days === 0 && workspaceSKU.workspacePlan?.planCode != 'TRIAL') {
      return `Subscription: Renews today`;
    } else if (days === 0 && workspaceSKU.workspacePlan?.planCode === 'TRIAL') {
      return 'Expiring Today';
    }
    return '';
  };

  const message = (days: number) => {
    if (
      workspaceSKU.workspacePlan?.planCode === 'TRIAL' ||
      workspaceSKU.workspacePlan?.planCode === 'PRM' ||
      workspaceSKU.workspacePlan?.planCode === 'STD'
    ) {
      return checkPlanForMessage(days);
    } else if (
      days <= 7 &&
      (workspaceSKU.workspacePlan?.planCode === 'ENT' ||
        workspaceSKU.workspacePlan?.planCode === 'PRO')
    ) {
      return checkPlanForMessage(days);
    }
    return '';
  };

  return (
    <RenAppBarr
      onClick={() => {
        workspaceSKU.workspacePlan?.planName === 'Trial' && sendEmailToSales();
        navigate('/plan/purchase');
      }}
    >
      <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
        <Tooltip
          title={workspaceSKU.workspacePlan?.planName === 'Trial' ? 'Click to request renewal' : ''}
        >
          {days !== null ? (
            <CustomChip
              sx={{ backgroundColor: colorHandler().bgColor }}
              label={
                <Stack direction="row" justifyContent="flex-end" alignItems="center">
                  <Label
                    sx={{ fontSize: '16px', fontWeight: 500, color: colorHandler().textColor }}
                  >
                    {message(days)}
                  </Label>

                  {days <= 7 && (
                    <MailOutlineIcon sx={{ marginLeft: 1, fill: colorHandler().textColor }} />
                  )}
                </Stack>
              }
            />
          ) : (
            <></>
          )}
        </Tooltip>
      </Stack>
    </RenAppBarr>
  );
};

export default NoticeUI;
